import React from 'react';
import Products from '../components/Products';

function ProductsPage() {
  return (
    <div>
      <Products />
    </div>
  );
}

export default ProductsPage;
